const toNumberOrNull = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const numberValue = Number(value);
    return Number.isNaN(numberValue) ? null : numberValue;
};

const hasValue = (value) => String(value || '').trim().length > 0;

const normalizeStatus = (value) => String(value || '').trim().toLowerCase();

export const MANUAL_NEXT_STEP_OPTIONS = [
    'Automatisch',
    'Erstgespräch',
    'Projektaudit',
    'Fragebogen',
    'Kundenportal',
    'Rückläufer prüfen',
    'Antworten und Reifecheck prüfen',
    'Nachforderung nötig',
    'Auf Nachforderung warten',
    'Antwortqualität schärfen',
    'Vorhabensbeschreibung',
    'Interne Prüfung',
    'Abschnitte intern prüfen',
    'Kundenfreigabe',
    'Abschnitte für Kunden freigeben',
    'Kundenreview',
    'Gutachterrückfragen',
    'Projektabrechnung',
    'Finalexport erstellen',
    'Finalisierung',
    'Antragspaket bereit',
    'Pausiert'
];

const MANUAL_ACTIONS = {
    'Erstgespräch': {
        tone: 'strong',
        stage: 'Manuell',
        title: 'Erstgespräch',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Erstgespräch öffnen',
        path: 'initial-consultation'
    },
    'Projektaudit': {
        tone: 'warning',
        stage: 'Manuell',
        title: 'Projektaudit',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Projektaudit öffnen',
        path: 'audit'
    },
    'Fragebogen': {
        tone: 'warning',
        stage: 'Manuell',
        title: 'Fragebogen erstellen oder prüfen',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Zum Projektaudit',
        path: 'audit'
    },
    'Kundenportal': {
        tone: 'warning',
        stage: 'Manuell',
        title: 'Kundenportal vorbereiten',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Kundenportal öffnen',
        path: 'customer-portal'
    },
    'Rückläufer prüfen': {
        tone: 'warning',
        stage: 'Manuell',
        title: 'Rückläufer prüfen',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Rückläufer öffnen',
        path: 'customer-portal'
    },
    'Antworten und Reifecheck prüfen': {
        tone: 'warning',
        stage: 'Manuell',
        title: 'Antworten und Reifecheck prüfen',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Rückläufer prüfen',
        path: 'customer-portal'
    },
    'Nachforderung nötig': {
        tone: 'danger',
        stage: 'Manuell',
        title: 'Nachforderung nötig',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Nachforderungen prüfen',
        path: 'customer-portal'
    },
    'Auf Nachforderung warten': {
        tone: 'danger',
        stage: 'Manuell',
        title: 'Auf Nachforderung warten',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Nachforderungen prüfen',
        path: 'customer-portal'
    },
    'Antwortqualität schärfen': {
        tone: 'warning',
        stage: 'Manuell',
        title: 'Antwortqualität schärfen',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Reifecheck öffnen',
        path: 'customer-portal'
    },
    'Vorhabensbeschreibung': {
        tone: 'strong',
        stage: 'Manuell',
        title: 'Vorhabensbeschreibung',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Vorhabensbeschreibung öffnen',
        path: 'description'
    },
    'Interne Prüfung': {
        tone: 'warning',
        stage: 'Manuell',
        title: 'Interne Prüfung',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Antragstext prüfen',
        path: 'description'
    },
    'Abschnitte intern prüfen': {
        tone: 'warning',
        stage: 'Manuell',
        title: 'Abschnitte intern prüfen',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Abschnitte prüfen',
        path: 'description'
    },
    'Kundenfreigabe': {
        tone: 'strong',
        stage: 'Manuell',
        title: 'Kundenfreigabe',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Freigabe öffnen',
        path: 'customer-portal'
    },
    'Abschnitte für Kunden freigeben': {
        tone: 'strong',
        stage: 'Manuell',
        title: 'Abschnitte für Kunden freigeben',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Freigabe steuern',
        path: 'description'
    },
    'Kundenreview': {
        tone: 'strong',
        stage: 'Manuell',
        title: 'Kundenfreigabe einholen',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Kundenreview öffnen',
        path: 'customer-portal'
    },
    'Gutachterrückfragen': {
        tone: 'warning',
        stage: 'Manuell',
        title: 'Gutachterrückfragen',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Rückfragen öffnen',
        path: 'reviewer-questions'
    },
    'Projektabrechnung': {
        tone: 'strong',
        stage: 'Manuell',
        title: 'Projektabrechnung',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Abrechnung öffnen',
        path: 'abrechnungen'
    },
    'Finalexport erstellen': {
        tone: 'strong',
        stage: 'Manuell',
        title: 'Finalexport erstellen',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Finalisieren',
        path: 'description'
    },
    'Finalisierung': {
        tone: 'success',
        stage: 'Manuell',
        title: 'Finalisierung',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Finalisierung öffnen',
        path: 'description'
    },
    'Antragspaket bereit': {
        tone: 'success',
        stage: 'Manuell',
        title: 'Antragspaket bereit',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Finalversion öffnen',
        path: 'description'
    },
    'Pausiert': {
        tone: 'danger',
        stage: 'Manuell',
        title: 'Projekt pausiert',
        detail: 'Dieser nächste Schritt wurde manuell gesetzt.',
        linkLabel: 'Projektübersicht öffnen',
        path: 'overview'
    }
};

const getManualAction = (manualNextStep = '') => {
    const step = MANUAL_NEXT_STEP_OPTIONS.includes(manualNextStep) ? manualNextStep : '';
    if (!step || step === 'Automatisch') {
        return null;
    }

    return MANUAL_ACTIONS[step] ? { ...MANUAL_ACTIONS[step], manual: true, manualNextStep: step } : null;
};

const getDescriptionStats = (project = {}) => {
    if (Array.isArray(project.descriptionSections)) {
        const sections = project.descriptionSections;
        return {
            total: sections.length,
            internalReviewed: sections.filter((section) => ['Intern geprüft', 'Final'].includes(section.status)).length,
            customerVisible: sections.filter((section) => section.customerVisible === true).length,
            customerReviewed: sections.filter((section) => ['Freigegeben', 'Änderungswunsch'].includes(section.customerReviewStatus)).length,
            finalExport: Boolean(project.descriptionFinalExport)
        };
    }

    return {
        total: Number(project.descriptionSectionCount || 0),
        internalReviewed: Number(project.descriptionInternalReviewedCount || 0),
        customerVisible: Number(project.descriptionCustomerVisibleCount || 0),
        customerReviewed: Number(project.descriptionCustomerReviewedCount || 0),
        finalExport: Boolean(project.descriptionFinalExport)
    };
};

const isBlankAnswer = (value) => !String(value || '').trim();

const isFollowUpQuestion = (question = {}) => {
    const status = question.answerStatus || 'Offen';
    const aiEvaluation = question.aiEvaluation || 'Nicht geprüft';

    if (status === 'Antwort reicht' || status === 'Intern geprüft') {
        return false;
    }

    return isBlankAnswer(question.answer) ||
        status === 'Offen' ||
        status === 'Unklar' ||
        status === 'Antwort reicht nicht' ||
        aiEvaluation === 'Kritisch' ||
        aiEvaluation === 'Zu vage' ||
        aiEvaluation === 'Fehlt';
};

const isReadyForApplicationText = (question = {}) => {
    return question.answerStatus === 'Antwort reicht' || question.answerStatus === 'Intern geprüft';
};

const getQuestionStats = (project = {}) => {
    const questions = Array.isArray(project.projectQuestions) ? project.projectQuestions : [];
    const explicitRequiredQuestions = questions.filter((question) => question.requiredStatus === 'Pflicht');
    const requiredQuestions = explicitRequiredQuestions.length > 0 || questions.length === 0
        ? explicitRequiredQuestions
        : questions;
    const openRequiredQuestions = requiredQuestions.filter((question) => isBlankAnswer(question.answer) || question.answerStatus === 'Offen');
    const unclearQuestions = questions.filter((question) => question.answerStatus === 'Unklar');
    const insufficientQuestions = questions.filter((question) => question.answerStatus === 'Antwort reicht nicht');
    const checkedQuestions = questions.filter((question) => question.answerStatus === 'Intern geprüft');
    const followUpQuestions = questions.filter(isFollowUpQuestion);
    const readyQuestions = questions.filter(isReadyForApplicationText);

    return {
        total: questions.length,
        openRequired: openRequiredQuestions.length,
        unclear: unclearQuestions.length,
        insufficient: insufficientQuestions.length,
        checked: checkedQuestions.length,
        followUp: followUpQuestions.length,
        ready: readyQuestions.length
    };
};

export const getProjectActionCenter = (project = {}) => {
    if (project.workflowCore?.nextAction?.title && project.workflowCore?.nextAction?.path) {
        return project.workflowCore.nextAction;
    }

    if (project.workflowDecision?.title && project.workflowDecision?.path) {
        return project.workflowDecision;
    }

    const manualAction = getManualAction(project.manualNextStep);
    if (manualAction) {
        return manualAction;
    }

    const fundingProgram = project.fundingProgram || project.recommendedProgram;
    const auditScore = toNumberOrNull(project.auditScore);
    const projectReadinessScore = toNumberOrNull(project.projectReadinessScore);
    const readinessScore = projectReadinessScore;
    const portalStatus = normalizeStatus(project.portalStatus);
    const descriptionStats = getDescriptionStats(project);
    const questionStats = getQuestionStats(project);
    const hasInitialConsultation = hasValue(project.initialConsultationNotes) || hasValue(project.initialScreeningResult);
    const initialNextStep = normalizeStatus(project.initialScreeningNextStep);
    const hasFundingProgram = hasValue(fundingProgram);
    const hasAudit = hasFundingProgram || auditScore !== null || hasValue(project.auditResult) || hasValue(project.gapAnalysis);
    const hasQuestionnaire = hasValue(project.questionnaire) || questionStats.total > 0;
    const hasPortal = hasValue(project.portalStatus) || hasValue(project.portalToken) || hasValue(project.portalLink);

    if (descriptionStats.total > 0) {
        if (descriptionStats.internalReviewed < descriptionStats.total) {
            return {
                tone: 'warning',
                stage: 'Interne Prüfung',
                title: 'Abschnitte intern prüfen',
                detail: `${descriptionStats.internalReviewed}/${descriptionStats.total} Abschnitte sind intern freigegeben.`,
                linkLabel: 'Abschnitte prüfen',
                path: 'description'
            };
        }

        if (descriptionStats.customerReviewed < descriptionStats.total) {
            if (descriptionStats.customerVisible < descriptionStats.total) {
                return {
                    tone: 'strong',
                    stage: 'Kundenfreigabe',
                    title: 'Abschnitte für Kunden freigeben',
                    detail: `${descriptionStats.customerVisible}/${descriptionStats.total} Abschnitte sind im Kundenportal sichtbar.`,
                    linkLabel: 'Freigabe steuern',
                    path: 'description'
                };
            }

            return {
                tone: 'strong',
                stage: 'Kundenreview',
                title: 'Kundenfreigabe einholen',
                detail: `${descriptionStats.customerReviewed}/${descriptionStats.total} Abschnitte wurden vom Kunden geprüft.`,
                linkLabel: 'Kundenreview öffnen',
                path: 'customer-portal'
            };
        }

        if (!descriptionStats.finalExport) {
            return {
                tone: 'strong',
                stage: 'Finalisierung',
                title: 'Finalexport erstellen',
                detail: 'Alle Abschnitte sind geprüft. Jetzt finale Version und Export erzeugen.',
                linkLabel: 'Finalisieren',
                path: 'description'
            };
        }

        return {
            tone: 'success',
            stage: 'Final',
            title: 'Antragspaket bereit',
            detail: 'Der Workflow ist bis zum Finalexport durchlaufen.',
            linkLabel: 'Finalversion öffnen',
            path: 'description'
        };
    }

    if (hasPortal || questionStats.total > 0) {
        if (questionStats.followUp > 0 || questionStats.openRequired > 0 || questionStats.insufficient > 0 || questionStats.unclear > 0) {
            const criticalCount = questionStats.followUp || (questionStats.openRequired + questionStats.insufficient + questionStats.unclear);
            return {
                tone: 'danger',
                stage: 'Nachforderung',
                title: 'Auf Nachforderung warten',
                detail: `${criticalCount} offene oder kritische Antwort(en) im Kundenportal. Frühere fehlende Schritte blockieren diesen Stand nicht.`,
                linkLabel: 'Nachforderungen prüfen',
                path: 'customer-portal'
            };
        }

        if (['entwurf', 'aktiv', 'gesendet'].includes(portalStatus) && readinessScore === null) {
            return {
                tone: 'warning',
                stage: 'Rückläufer',
                title: 'Antworten und Reifecheck prüfen',
                detail: 'Kundenportal ist vorbereitet. Prüfe Rücklauf, Antwortstatus und Projekt-Reife.',
                linkLabel: 'Rückläufer prüfen',
                path: 'customer-portal'
            };
        }

        if (readinessScore !== null && readinessScore < 75) {
            return {
                tone: 'danger',
                stage: 'Nachforderung',
                title: 'Nachlieferung nötig',
                detail: `Projekt-Reife liegt bei ${readinessScore}/100. Offene Punkte vor Antragstext klären.`,
                linkLabel: 'Nachforderungen prüfen',
                path: 'customer-portal'
            };
        }

        if (readinessScore !== null && readinessScore < 85) {
            return {
                tone: 'warning',
                stage: 'Interne Prüfung',
                title: 'Antwortqualität schärfen',
                detail: `Projekt-Reife liegt bei ${readinessScore}/100. Antrag möglich, aber noch mit Prüfrisiko.`,
                linkLabel: 'Reifecheck öffnen',
                path: 'customer-portal'
            };
        }

        return {
            tone: 'strong',
            stage: 'Antragstext',
            title: 'Vorhabensbeschreibung erstellen',
            detail: `${questionStats.ready || questionStats.total}/${questionStats.total} Projektantworten sind antragsbereit. Jetzt den Antragstext starten.`,
            linkLabel: 'Antragstext starten',
            path: 'description'
        };
    }

    if (hasQuestionnaire) {
        return {
            tone: 'warning',
            stage: 'Kundenportal',
            title: 'Kundenportal vorbereiten',
            detail: 'Der Fragebogen ist da, aber der Kundenportal-Flow ist noch nicht vorbereitet.',
            linkLabel: 'Portal vorbereiten',
            path: 'customer-portal'
        };
    }

    if (hasAudit) {
        if (!hasFundingProgram) {
            return {
                tone: 'danger',
                stage: 'Audit',
                title: 'Förderprogramm klären',
                detail: 'Auditdaten sind vorhanden, aber noch kein Förderprogramm hinterlegt.',
                linkLabel: 'Zum Projektaudit',
                path: 'audit'
            };
        }

        if (auditScore === null) {
            return {
                tone: 'warning',
                stage: 'Audit',
                title: 'Audit Score fehlt',
                detail: 'Bewerte den Förderfit, damit die nächsten Schritte sauber priorisiert werden.',
                linkLabel: 'Audit prüfen',
                path: 'audit'
            };
        }

        return {
            tone: 'warning',
            stage: 'Fragebogen',
            title: 'Fragebogen erstellen',
            detail: 'Das Audit ist vorhanden. Erstelle nun den strukturierten Kundenfragebogen.',
            linkLabel: 'Fragebogen erstellen',
            path: 'audit'
        };
    }

    if (!hasInitialConsultation) {
        return {
            tone: 'strong',
            stage: 'Erstgespräch',
            title: 'Kennenlernen vorbereiten',
            detail: 'Vor dem Projektaudit fehlen noch Gesprächsnotizen oder ein erstes Förder-Screening.',
            linkLabel: 'Erstgespräch öffnen',
            path: 'initial-consultation'
        };
    }

    if (hasInitialConsultation && !hasValue(project.initialScreeningResult)) {
        return {
            tone: 'warning',
            stage: 'Erstscreening',
            title: 'Förderpotenzial grob einordnen',
            detail: 'Gesprächsnotizen sind vorhanden. Führe das Erstscreening aus, bevor du ins Projektaudit gehst.',
            linkLabel: 'Erstscreening starten',
            path: 'initial-consultation'
        };
    }

    if (initialNextStep === 'weitere basisinfos einholen' && auditScore === null) {
        return {
            tone: 'warning',
            stage: 'Erstgespräch',
            title: 'Basisinfos nachfassen',
            detail: 'Das Erstscreening sieht noch zu wenig Substanz für ein belastbares Projektaudit.',
            linkLabel: 'Erstgespräch prüfen',
            path: 'initial-consultation'
        };
    }

    if (initialNextStep === 'aktuell nicht passend' && auditScore === null) {
        return {
            tone: 'danger',
            stage: 'Erstgespräch',
            title: 'Aktuell nicht passend',
            detail: 'Das Erstscreening erkennt keine belastbare Förderperspektive. Prüfe die Einschätzung vor weiteren Schritten.',
            linkLabel: 'Erstscreening prüfen',
            path: 'initial-consultation'
        };
    }

    return {
        tone: 'warning',
        stage: 'Audit',
        title: 'Projektaudit starten',
        detail: 'Das Erstgespräch ist erfasst. Starte jetzt die Förderprüfung.',
        linkLabel: 'Zum Projektaudit',
        path: 'audit'
    };
};

export const getProjectActionPath = (projectId, action) => {
    if (!projectId || !action?.path) return '/projects';
    return `/project/${projectId}/${action.path}`;
};

const getContextualActionBase = (project = {}) => {
    const fundingProgram = project.fundingProgram || project.recommendedProgram;
    const auditScore = toNumberOrNull(project.auditScore);
    const projectReadinessScore = toNumberOrNull(project.projectReadinessScore);
    const portalStatus = normalizeStatus(project.portalStatus);
    const descriptionStats = getDescriptionStats(project);
    const questionStats = getQuestionStats(project);
    const hasInitialConsultation = hasValue(project.initialConsultationNotes) || hasValue(project.initialScreeningResult);
    const hasFundingProgram = hasValue(fundingProgram);
    const hasAudit = hasFundingProgram || auditScore !== null || hasValue(project.auditResult) || hasValue(project.gapAnalysis);
    const hasAuditDecisionBasis = hasAudit;
    const hasQuestionnaire = hasValue(project.questionnaire) || questionStats.total > 0;
    const hasPortal = hasValue(project.portalStatus) || hasValue(project.portalToken) || hasValue(project.portalLink);

    return {
        auditScore,
        projectReadinessScore,
        portalStatus,
        descriptionStats,
        questionStats,
        hasInitialConsultation,
        hasFundingProgram,
        hasAudit,
        hasAuditDecisionBasis,
        hasQuestionnaire,
        hasPortal
    };
};

const action = ({
    id,
    label,
    detail = '',
    tone = 'neutral',
    path = '',
    actionKey = '',
    primary = false,
    kind = 'navigate'
}) => ({
    id,
    label,
    detail,
    tone,
    path,
    actionKey,
    primary,
    kind
});

export const getContextualActions = (project = {}, context = 'dashboard') => {
    const base = getContextualActionBase(project);
    const actions = [];

    const add = (item) => {
        if (!item?.id || actions.some((existing) => existing.id === item.id)) return;
        actions.push(item);
    };

    const nextAction = getProjectActionCenter(project);
    if (nextAction?.path) {
        add(action({
            id: 'next-action',
            label: nextAction.linkLabel || nextAction.title || 'Nächsten Schritt öffnen',
            detail: nextAction.detail || '',
            tone: nextAction.tone || 'strong',
            path: nextAction.path,
            primary: true
        }));
    }

    if (project.decisionGate?.decisionRequired) {
        add(action({
            id: 'gate-decision',
            label: 'Gate entscheiden',
            detail: project.decisionGate.question || 'Offene Workflow-Entscheidung protokollieren.',
            tone: 'decision',
            path: context === 'dashboard' ? '' : 'dashboard'
        }));
    }

    if (context === 'initial-consultation') {
        if (!hasValue(project.initialScreeningResult)) {
            add(action({ id: 'initial-screening', label: 'Erstscreening durchführen', detail: 'Gesprächsnotizen in Förderhypothesen, Red Flags und nächste Klärungen übersetzen.', tone: 'strong' }));
        }
        add(action({ id: 'initial-questions-sent', label: 'Klärungsfragen gesendet', detail: 'Versand dokumentieren und Kundenantwort-Frist starten.', tone: 'strong', actionKey: 'initial_questions_sent', kind: 'workflow' }));
        add(action({ id: 'audit-open', label: 'Ins Audit wechseln', detail: 'Projekt fachlich prüfen und Förderprogramm festlegen.', tone: 'warning', path: 'audit' }));
    }

    if (context === 'audit') {
        const latestGateDecision = normalizeStatus(project.decisionGate?.latestDecision?.decision);
        const isAuditGate = normalizeStatus(project.decisionGate?.title || '').includes('audit') ||
            normalizeStatus(project.decisionGate?.key || '').includes('audit');
        const isAuditGateDecisionOpen = isAuditGate && project.decisionGate?.decisionRequired === true;
        const isAuditGateApproved = latestGateDecision === 'go' &&
            isAuditGate;

        if (!base.hasFundingProgram || base.auditScore === null) {
            add(action({ id: 'analyze-funding-fit', label: 'Förderfähigkeit analysieren', detail: 'Programmfit, Score, Lücken und Entscheidungsvorlage erzeugen.', tone: 'strong' }));
        }
        if (!base.hasQuestionnaire) {
            add(action({
                id: 'generate-questionnaire',
                label: 'Fragebogen erstellen',
                detail: base.hasAuditDecisionBasis
                    ? 'Offene Prüfdimensionen in Kundenfragen überführen.'
                    : 'Erst Audit-Ergebnis, Programm oder Score sichern, damit keine leeren Fragen entstehen.',
                tone: base.hasAuditDecisionBasis ? 'warning' : 'neutral'
            }));
        }
        if (isAuditGateDecisionOpen && !isAuditGateApproved) {
            add(action({ id: 'audit-go', label: 'Audit Go dokumentieren', detail: 'Weiterführung protokollieren und Portalfrist erzeugen.', tone: 'strong', actionKey: 'audit_go', kind: 'workflow' }));
            add(action({ id: 'audit-stop', label: 'Audit Stop dokumentieren', detail: 'Stop-Entscheidung in Timeline und Gate-Logik festhalten.', tone: 'danger', actionKey: 'audit_stop', kind: 'workflow' }));
        }
    }

    if (context === 'customer-portal') {
        if (base.hasQuestionnaire && !base.hasPortal) {
            add(action({ id: 'portal-open', label: 'Portal vorbereiten', detail: 'Fragebogen und Unternehmensdaten für den Kunden öffnen.', tone: 'strong', path: 'customer-portal' }));
        }
        add(action({ id: 'portal-sent', label: 'Portal gesendet', detail: 'Versand dokumentieren und 14-Tage-Kundenerinnerung starten.', tone: 'strong', actionKey: 'portal_sent', kind: 'workflow' }));
        if (base.questionStats.followUp > 0 || base.questionStats.openRequired > 0 || ['aktiv', 'gesendet'].includes(base.portalStatus)) {
            add(action({ id: 'customer-reminded', label: 'Kunde erinnern', detail: 'Nachfassen dokumentieren, ohne den Projektstatus zu verwässern.', tone: 'warning', actionKey: 'customer_reminded', kind: 'workflow' }));
        }
        if (base.projectReadinessScore !== null && base.projectReadinessScore >= 75) {
            add(action({ id: 'description-open', label: 'Antragstext starten', detail: 'Geprüften Kundeninput in die Vorhabensbeschreibung übernehmen.', tone: 'strong', path: 'description' }));
        }
    }

    if (context === 'description') {
        add(action({ id: 'import-application-input', label: 'Antragsinput übernehmen', detail: 'Audit, Kundenportal, Evidence Map und Draft Engine neu laden.', tone: 'strong' }));
        if (project.applicationDraftEngine?.summary?.draftReadySections > 0 || project.applicationDraftEngine?.summary?.constrainedSections > 0) {
            add(action({ id: 'generate-description', label: 'Vorhabensbeschreibung erstellen', detail: 'Abschnittspläne und Claims Library beim Schreiben nutzen.', tone: 'strong' }));
        }
        if (base.descriptionStats.total > 0 && base.descriptionStats.internalReviewed < base.descriptionStats.total) {
            add(action({ id: 'review-sections', label: 'Abschnitte intern prüfen', detail: `${base.descriptionStats.internalReviewed}/${base.descriptionStats.total} Abschnitte intern freigegeben.`, tone: 'warning' }));
        }
        if (base.descriptionStats.internalReviewed > 0 && base.descriptionStats.customerVisible < base.descriptionStats.total) {
            add(action({ id: 'release-reviewed-sections', label: 'Intern geprüfte freigeben', detail: 'Abschnitte für Kundenreview im Portal sichtbar machen.', tone: 'strong' }));
        }
    }

    if (context === 'dashboard') {
        add(action({ id: 'contact-log', label: 'Kontakt dokumentieren', detail: 'Projektkontakt und Folgedatum erfassen.', tone: 'neutral', actionKey: 'contact_attempt_logged', kind: 'workflow' }));
        add(action({ id: 'pause-project', label: 'Pausieren', detail: 'Projekt bewusst aus operativer Bearbeitung nehmen.', tone: 'danger', actionKey: 'pause_project', kind: 'workflow' }));
    }

    return actions.slice(0, 6);
};
